import { render } from "./company.vue?vue&type=template&id=eb70a458&scoped=true&ts=true"
import script from "./company.vue?vue&type=script&lang=ts"
export * from "./company.vue?vue&type=script&lang=ts"

import "./company.vue?vue&type=style&index=0&id=eb70a458&scoped=true&lang=css"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb70a458"]])

export default __exports__